// @flow strict
import * as React from 'react'
import cx from 'classnames'

import Picture from './Picture'
import styles from './Card.module.scss'
import Label from './Label'
import { BespokeCardContent } from './Content'
import ResponsiveImage from '../../atoms/ResponsiveImage/ResponsiveImage'

type Props = {
  className?: string,
  children: React.ChildrenArray<
    | React.Element<typeof Picture>
    | React.Element<typeof Label>
    | React.Element<typeof BespokeCardContent>
    | React.Element<typeof ResponsiveImage>,
  >,
}

const Media = ({ children, className }: Props) => (
  <div className={cx(styles.media, className)}>{children}</div>
)

export default Media
